import React from 'react'

import { IconProps } from '../../../common/types'

const ChavronLeft: React.FC<IconProps> = () => {
  return (
    <svg
      width="25"
      height="15"
      viewBox="0 0 25 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.50194 7.5H23.2969M23.2969 7.5L17.2969 1.5M23.2969 7.5L17.2969 13.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ChavronLeft
